import { useFlags, useLDClient } from 'launchdarkly-react-client-sdk';
import { useContext, useEffect, useState } from 'react';
import usePaginatedEvents from './PaginatedEvents';
import { EventDateContext } from 'contexts/eventDate';
import { EventStatusContext } from 'contexts/eventStatus';
import { EventTypeContext } from 'contexts/eventType';
import { useCurrentUserState } from 'contexts/user';
import { initLaunchDarkly } from 'helpers/launchDarkly';
import { EVENTS_PAGINATION_PAGE_SIZE } from 'modules/events/basics/constants/list.constants';
import { MarketWithAll } from 'modules/events/basics/types/events.types';
import eventState from 'modules/events/states/events.states';

const useEvents = (isPast: boolean) => {
  const { user } = useCurrentUserState();
  const market = user?.market ? user.market as MarketWithAll : null;
  const [showManageSpeakersModal, setShowManageSpeakersModal] = useState(false);
  const [showManageJourneysModal, setShowManageJourneysModal] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(EVENTS_PAGINATION_PAGE_SIZE);
  const ldClient = useLDClient();
  const flags = useFlags();
  const showRsvpEvents = flags.eventsBiogenlinc4973ShowRsvpEvents;

  const eventDateContext = useContext(EventDateContext);
  const eventStatusContext = useContext(EventStatusContext);
  const eventTypeContext = useContext(EventTypeContext);

  if (user && user?.market) {
    initLaunchDarkly(ldClient, user, user?.market);
  }

  const {
    data,
    loading,
    error,
    totalCount,
  } = usePaginatedEvents({
    isPast,
    market,
    showRsvpEvents,
    sortOrder: 'asc',
    pageSize,
    page,
    eventStatus: eventStatusContext.eventStatus,
    eventType: eventTypeContext.eventType,
    dateRange: eventDateContext.date,
  });

  const onManageSpeakersModalOpen = () => {
    setShowManageSpeakersModal(true);
  };

  const onManageSpeakersModalClose = () => {
    setShowManageSpeakersModal(false);
  };

  const onManageJourneysModalOpen = () => {
    setShowManageJourneysModal(true);
  };

  const onManageJourneysModalClose = () => {
    setShowManageJourneysModal(false);
  };

  useEffect(() => {
    eventState.createEvent = {};
  }, []);

  useEffect(() => {
    setPage(0);
  }, [market, eventStatusContext.eventStatus, eventTypeContext.eventType, eventDateContext.date]);

  return {
    upcomingEvents: data || [],
    loadingUpcoming: loading,
    error,
    onManageSpeakersModalOpen,
    onManageSpeakersModalClose,
    showManageSpeakersModal,
    onManageJourneysModalOpen,
    onManageJourneysModalClose,
    showManageJourneysModal,
    page,
    setPage,
    pageSize,
    setPageSize,
    totalCount,
  };
};

export default useEvents;
